import { createSlice } from "@reduxjs/toolkit";

export const verificationRequestsSlice = createSlice({
  name: "verificationRequests",
  initialState: {
    pendingRequests: {
      list: [],
      meta: {},
    },
    requestsHistory: {
      list: [],
      meta: {},
    },
  },
  reducers: {
    getPendingRequestsListRequest: () => {},
    getPendingRequestsListResponse: (state, action) => {
      state.pendingRequests.list = action.payload?.requests;
      state.pendingRequests.meta = action.payload?.meta;
    },
    getRequestsHistoryListRequest: () => {},
    getRequestsHistoryListResponse: (state, action) => {
      state.requestsHistory.list = action.payload?.requests;
      state.requestsHistory.meta = action.payload?.meta;
    },
  },
});

export const {
  getPendingRequestsListRequest,
  getPendingRequestsListResponse,
  getRequestsHistoryListRequest,
  getRequestsHistoryListResponse,
} = verificationRequestsSlice.actions;
export default verificationRequestsSlice.reducer;
